"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var Components_1 = require("../../Components");
var storyblok_react_1 = __importDefault(require("storyblok-react"));
var storyblok_js_client_1 = __importDefault(require("storyblok-js-client"));
var loadStoryblokBridge = function (config, cb) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//app.storyblok.com/f/storyblok-latest.js?t=" + config.accessToken;
    script.onload = cb;
    document.getElementsByTagName("head")[0].appendChild(script);
};
var getParam = function (val) {
    var result = "";
    var tmp = [];
    window.location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
        tmp = item.split("=");
        if (tmp[0] === val) {
            result = decodeURIComponent(tmp[1]);
        }
    });
    return result;
};
var StoryblokEditor = /** @class */ (function (_super) {
    __extends(StoryblokEditor, _super);
    function StoryblokEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.client = new storyblok_js_client_1["default"](_this.props.config);
        _this.state = {
            story: null,
            global: null
        };
        _this.loadStory = function (path) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.get("cdn/stories/" + path, {
                            version: "draft"
                        })];
                    case 1:
                        result = _a.sent();
                        this.setState({ story: result.data.story });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.loadGlobalComponent = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getStory("global")];
                    case 1:
                        result = _a.sent();
                        this.setState({ global: result.data.story });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.initStoryblokEvents = function () {
            _this.loadGlobalComponent();
            _this.loadStory(getParam("path"));
            // this.loadGlobalNavi();
            var sb = window.storyblok;
            sb.on(["change", "published"], function (payload) {
                _this.loadStory(payload.slug);
            });
            sb.on("input", function (payload) {
                _this.loadStory(payload.story.slug);
            });
            // sb.pingEditor(() => {
            //   if (sb.inEditor) {
            //     sb.enterEditmode()
            //   }
            // })
        };
        return _this;
    }
    StoryblokEditor.prototype.componentDidMount = function () {
        loadStoryblokBridge(this.props.config, this.initStoryblokEvents);
    };
    StoryblokEditor.prototype.render = function () {
        if (this.state.story == null) {
            return (React.createElement("div", null));
        }
        var content = this.state.story.content;
        return (React.createElement(storyblok_react_1["default"], { content: content }, React.createElement(Components_1.Components(content.component), { key: content._uid, blok: content })));
    };
    return StoryblokEditor;
}(React.Component));
exports.StoryblokEditor = StoryblokEditor;
